<template>
  <div id="info">
    <a-popover trigger="click" placement="topRight" v-model="visible">
      <template slot="content" >
        <div style="width: 450px;">
          <a-row style="text-align: left;">
            <a-col span="8" style="color: #0b97c4;padding: 10px;">{{$t('menu.NotificationList')+'('+ filterNum +')'}}</a-col>
            <a-col span="11">
              <a-input :style="{ visibility: sysEnableTextFilter != 'Y' ? 'hidden' : 'visible' }" style="margin-top: 5px;" @pressEnter="inputTextFilter(false)" v-model="inputText" :placeholder="$t('inputNumCharsThenPressEnter',{'0':this.enableTextFilter2})"></a-input>
            </a-col>
            <a-col span="2" offset="1" style="margin-top: 5px;" v-if="this.systemParam.NOTIFICATION_FILTER_BY_TYPE != undefined ||
                                                                      this.systemParam.NOTIFICATION_FILTER_BY_TIME != undefined ||
                                                                      this.systemParam.NOTIFICATION_FILTER_BY_READ != undefined ||
                                                                      this.systemParam.NOTIFICATION_FILTER_BY_RESULT != undefined">
              <a-popover trigger="click" placement="bottom" v-model:visible="isPopoverVisible">
                <a-badge :dot="showBadge">
                  <img v-show="this.isChecked" src="./filter.png" style="height: 30px;width: 30px;border: 1px solid #389AD1;border-radius: 5px;cursor: pointer;padding: 2px;" @click="clickFilter()"/>
                  <img v-show="!this.isChecked" src="./filter2.png" style="height: 30px;width: 30px;border: 1px solid #389AD1;border-radius: 5px;cursor: pointer;background-color: #389AD1;padding: 2px;" @click="clickFilter()"/>
                </a-badge>
                <template slot="content">
                  <a-row style="width: 200px;padding:10px;">
                    <a-col style="padding-bottom: 10px;">{{$t('filterBy')}}</a-col>
                    <a-col>
                      <el-radio-group v-model="filterByType" style="display: flex;flex-direction: column;" @change="handleRadioChange">
                        <el-radio label="NA" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByType === 'NA' }"></span>
                          {{$t('batchReceive.All')}}
                        </el-radio>
                        <el-radio label="ALL" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByType === 'ALL' }"></span>
                          {{$t('allocationResults')}}
                        </el-radio>
                        <el-radio label="IMPORT" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByType === 'IMPORT' }"></span>
                          {{$t('importResults')}}
                        </el-radio>
                      </el-radio-group>
                      <a-divider style="margin: 10px 0"/>
                    </a-col>
                    <a-col>
                      <el-radio-group v-model="filterByTime" style="display: flex;flex-direction: column;" @change="handleRadioChange">
                        <el-radio label="LATEST" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByTime === 'LATEST' }"></span>
                          {{$t('lastestNotifications',{"0":this.filterByTime2})}}
                        </el-radio>
                        <el-radio label="TODAY" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByTime === 'TODAY' }"></span>
                          {{$t('todayNotifications')}}
                        </el-radio>
                        <el-radio label="YESTERDAY" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByTime === 'YESTERDAY' }"></span>
                          {{$t('yesterdayNotifications')}}
                        </el-radio>
                      </el-radio-group>
                      <a-divider style="margin: 10px 0"/>
                    </a-col>
                    <a-col>
                      <el-radio-group v-model="filterByRead" style="display: flex;flex-direction: column;" @change="handleRadioChange">
                        <el-radio label="NA" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByRead === 'NA' }"></span>
                          {{$t('batchReceive.All')}}
                        </el-radio>
                        <el-radio label="READ" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByRead === 'READ' }"></span>
                          {{$t('menu.Read')}}
                        </el-radio>
                        <el-radio label="UNREAD" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByRead === 'UNREAD' }"></span>
                          {{$t('menu.Unread')}}
                        </el-radio>
                      </el-radio-group>
                      <a-divider style="margin: 10px 0"/>
                    </a-col>
                    <a-col>
                      <el-radio-group v-model="filterByResult" style="display: flex;flex-direction: column;width: 100%;" @change="handleRadioChange">
                        <el-radio label="NA" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByResult === 'NA' }"></span>
                          {{$t('batchReceive.All')}}
                        </el-radio>
                        <el-radio label="SUCCESS" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByResult === 'SUCCESS' }"></span>
                          {{$t('success')}}
                        </el-radio>
                        <el-radio label="FAILED" style="padding-top: 5px;">
                          <span class="custom-radio-image" :class="{ 'active': filterByResult === 'FAILED' }"></span>
                          {{$t('failed')}}
                        </el-radio>
                      </el-radio-group>
                      <a-divider style="margin: 10px 0"/>
                    </a-col>
                    <a-col>
                      <a-row style="text-align: center;">
                        <a-col span="12"><a-button style="border: 0px;color: #00A8C3" @click="inputFilter(false)">{{$t('generic.Apply')}}</a-button></a-col>
                        <a-col span="12"><a-button style="border: 0px;" @click="clearFilter">{{$t('publicLang.Clear')}}</a-button></a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                </template>
              </a-popover>
            </a-col>
          </a-row>
          <div style="height: 45vh; overflow-y: auto;">
            <ul v-if="infoTable.length > 0">
              <li class="cotificationLi" @click="cellClickEvent(item)" v-for="item in infoTable" style="border-bottom: 1px solid #efefef;">
                <a-row type="flex" justify="space-around" align="middle">
                  <a-col :span="20">
                    <a-row type="flex" justify="start" align="middle">
                      <a-col style="margin:0 15px">
                        <img src="./infoAvr.png" alt="" width="30" height="30">
                      </a-col>
                      <a-col>
                        <p style="font-size: 14px;margin-bottom: 4px;">{{item.refNum}}</p>
                        <p style="rgba(0,0,0,.45);font-size: 12px;margin-bottom: 4px;">{{item.refType}}</p>
                        <p style="color: rgba(0,0,0,.45);font-size: 12px;margin-bottom:0;">{{item.creatTime}}</p>
                      </a-col>
                    </a-row>
                  </a-col >
                  <a-col :span="4">
                    <a-tag color="#87d068" v-if="item.readStatus">{{ $t('menu.Read') }}</a-tag>
                    <a-tag color="rgba(0,0,0,.45)" v-else>{{ $t('menu.Unread') }}</a-tag>
                  </a-col>
                </a-row>
              </li>
            </ul>
            <div v-else class="flexClass">
                <span style="text-align: center;">
                  <img src="../../assets/img/nodataInfo.svg" alt="" style="margin: 15px 0 10px 0">
                  <p>{{ $t('menu.YouhaveViewedNotifications') }}</p>
                </span>
            </div>
          </div>
          <!--infoTable.length > 0-->
          <a-row v-if="false" style="border-top: 1px solid #efefef;line-height: 35px;" type="flex" justify="start">
            <a-col :span="12" style="text-align: center;border-right: 1px solid #efefef;" @click="clearNotifiaction">{{ $t('publicLang.Clear') }}</a-col>
            <a-col :span="12" style="text-align: center;" @click="viewMoreNotif">{{ $t('menu.ViewMore') }}</a-col>
          </a-row>
        </div>
      </template>
      <a-badge :count="conutNum" @click="info">
        <a href="javascript:;">
          <a-icon type="bell" :style="{fontSize: '22px',color: seetingPageTypeBuju ? 'black':'white'}"></a-icon>
        </a>
      </a-badge>
    </a-popover>
    <a-modal
            title="Notification"
            v-model="ificationvis"
            width="75%"
    >
      <template slot="footer">
        <a-button size="small" type="danger" @click="() => (ificationvis = !ificationvis)">Close</a-button>
      </template>
      <a-row>
        <div class="infoDetail">
          <span class="infoDetail_L">{{ $t('menu.Subject') }}: </span>
          <span class="infoDetail_R">{{detailHeader.subject}}</span>
        </div>
        <div class="infoDetail">
          <span class="infoDetail_L">{{ $t('menu.RefType') }}: </span>
          <span class="infoDetail_R">{{detailHeader.refType}}</span>
        </div>
        <div class="infoDetail">
          <span class="infoDetail_L">{{ $t('menu.RefNum') }}: </span>
          <span class="infoDetail_R">{{detailHeader.refNum}}</span>
        </div>
        <div class="infoDetail">
          <span class="infoDetail_L">{{ $t('menu.StartTime') }}: </span>
          <span class="infoDetail_R">{{detailHeader.creatTime}}</span>
        </div>
        <div class="infoDetail">
          <span class="infoDetail_L">{{ $t('menu.CompleteTime') }}: </span>
          <span class="infoDetail_R">{{detailHeader.completedTime}}</span>
        </div>
      </a-row>
      <a-divider />
      <div class="infodetailContext">
        <div v-html="detailHeader.content"></div>
      </div>
      <!-- <a-divider /> -->
      <!-- <vxe-table
          border
          resizable
          :data.sync="detailTable"
          highlight-hover-row
          stripe
          size="mini"
          :max-height="300"
      >
        <template v-slot:empty>
          {{ $t('menu.NoRecordfound') }}
        </template>
        <vxe-table-column
                show-overflow
                show-header-overflow
                field="userAccount"
                :title="$t('menu.Receiver')"
        >
        </vxe-table-column>

        <vxe-table-column
                show-overflow
                show-header-overflow
                field="readTime"
                :title="$t('menu.ReadTime')"
        >
        </vxe-table-column>
      </vxe-table> -->
    </a-modal>
  </div>
</template>
<script>
  import ajax from '../../api/ajax'
  import api from '../../api/url'
  import cookie from '../../api/cookie'
  import moment from 'moment'
  import {mapState} from "vuex";
  export default{
    data(){
      return {
        visible: false,
        conutNum: 0,
        ificationvis: false,
        infoTable: [],
        page:{
          currentVal: 1,
          pagingSize: 30
        },
        detailTable: [], // detailTable table
        detailHeader: {},// detailTable header
        sysEnableTextFilter:'N',
        inputText:'',
        filterByType:'',
        filterByTime:'',
        filterByTime2:30,
        filterByRead:'',
        filterByResult:'',
        enableTextFilter2:0,
        tempInfoTable: [],
        filterNum: 0,
        isChecked :true,
        showBadge:false,
        isPopoverVisible:false,
      }
    },
    props:{
      seetingPageTypeBuju: {
        type: Boolean,
        default: function() {
          return true
        }
      },
    },
    created(){
      this.inputFilter(true);
    },
    computed: {
      ...mapState(["systemParam"])
    },
    watch: {
      isPopoverVisible(val) {
        if (!val) {
          this.isChecked = true
        }
      }
    },
    methods:{
      clearNotifiaction(){
        this.infoTable = []
      },
      viewMoreNotif(){},
      info(type){
        this.sysEnableTextFilter = this.systemParam.NOTIFICATION_ENABLE_TEXT_FILTER == undefined ? "N" : this.systemParam.NOTIFICATION_ENABLE_TEXT_FILTER;
        this.enableTextFilter2 = this.systemParam.NOTIFICATION_ENABLE_TEXT_FILTER2 == undefined ? "0" : this.systemParam.NOTIFICATION_ENABLE_TEXT_FILTER2;
        this.filterByType = this.systemParam.NOTIFICATION_FILTER_BY_TYPE == undefined ? "NA" : this.systemParam.NOTIFICATION_FILTER_BY_TYPE;
        this.filterByTime = this.systemParam.NOTIFICATION_FILTER_BY_TIME == undefined ? "LATEST" : this.systemParam.NOTIFICATION_FILTER_BY_TIME;
        this.filterByTime2 = this.systemParam.NOTIFICATION_FILTER_BY_TIME2 == undefined ? "30" : this.systemParam.NOTIFICATION_FILTER_BY_TIME2;
        this.filterByRead = this.systemParam.NOTIFICATION_FILTER_BY_READ == undefined ? "NA" : this.systemParam.NOTIFICATION_FILTER_BY_READ;
        this.filterByResult = this.systemParam.NOTIFICATION_FILTER_BY_RESULT == undefined ? "NA" : this.systemParam.NOTIFICATION_FILTER_BY_RESULT;
        this.isChecked = true;
        this.inputText = '';
        this.showBadge = false;
        this.inputFilter(true);
      },
      cellClickEvent(row){
        this.detailHeader= row;
        this.visible = false
        ajax.get(api.MSGCONTENT,{uid: row.uid}).then(res=>{
          // this.detailTable = res.data.msgUserList
          this.detailHeader.content = res.data.msg
          this.ificationvis = true
          // if(this.detailTable.length > 0){
          //     for(let ii in this.detailTable){
          //         if(this.detailTable[ii].readTime != null){
          //             this.detailTable[ii].readTime = moment(this.detailTable[ii].readTime).format("YYYY-MM-DD HH:mm:ss");
          //         }
          //     }
          // }
        })
      },
      showNotificationByOrderUid(uid,type){
        this.visible = false
        ajax.get(api.GETMSGBYORDER,{orderUid: uid,orderType:type}).then(res=>{
          this.detailHeader= res.data.msgSubject;
          this.detailHeader.content = res.data.msg
          this.ificationvis = true
        })
      },
      clearFilter(){
        this.filterByType = this.systemParam.NOTIFICATION_FILTER_BY_TYPE == undefined ? "NA" : this.systemParam.NOTIFICATION_FILTER_BY_TYPE;
        this.filterByTime = this.systemParam.NOTIFICATION_FILTER_BY_TIME == undefined ? "LATEST" : this.systemParam.NOTIFICATION_FILTER_BY_TIME;
        this.filterByRead = this.systemParam.NOTIFICATION_FILTER_BY_READ == undefined ? "NA" : this.systemParam.NOTIFICATION_FILTER_BY_READ;
        this.filterByResult = this.systemParam.NOTIFICATION_FILTER_BY_RESULT == undefined ? "NA" : this.systemParam.NOTIFICATION_FILTER_BY_RESULT;
        this.handleRadioChange();
      },
      inputFilter(sumNum){
        this.isPopoverVisible = false
        this.isChecked = true
        let params = {
          pageNum: this.page.currentVal,
          pageSize: this.page.pagingSize,
          filterByType: this.filterByType,
          filterByTime: this.filterByTime,
          filterByTime2: this.filterByTime2,
          filterByRead: this.filterByRead,
          filterByResult: this.filterByResult,
        }
        ajax.get(api.INFEOTABLEMSG,params).then(res=>{
          if(res.code == 200){
            this.infoTable = res.data.content
            let num = 0
            for(let i in this.infoTable){
              // if(!this.infoTable[i].readStatus){
                num = num + 1
              // }
            }
            this.filterNum = num
            if(sumNum == true){
              this.conutNum = num
            }
          }
        })
      },
      inputTextFilter(sumNum){
        if(this.inputText.length >= this.enableTextFilter2){
          if(this.tempInfoTable.length == 0){
            this.tempInfoTable = this.infoTable;
          }else {
            this.infoTable = this.tempInfoTable;
          }
          this.infoTable = this.infoTable.filter(item => item.refNum.includes(this.inputText));
        }
      },
      clickFilter(){
        this.isChecked = !this.isChecked
      },
      handleRadioChange(){
        if(this.filterByType != (this.systemParam.NOTIFICATION_FILTER_BY_TYPE == undefined ? "NA" : this.systemParam.NOTIFICATION_FILTER_BY_TYPE) ||
                this.filterByTime != (this.systemParam.NOTIFICATION_FILTER_BY_TIME == undefined ? "LATEST" : this.systemParam.NOTIFICATION_FILTER_BY_TIME) ||
                this.filterByRead != (this.systemParam.NOTIFICATION_FILTER_BY_READ == undefined ? "NA" : this.systemParam.NOTIFICATION_FILTER_BY_READ) ||
                this.filterByResult != (this.systemParam.NOTIFICATION_FILTER_BY_RESULT == undefined ? "NA" : this.systemParam.NOTIFICATION_FILTER_BY_RESULT)){
          this.showBadge = true
        }else {
          this.showBadge = false
        }
      },
    }
  }
</script>
<style lang="less">
  .ant-popover-inner-content{
    padding: 0;
  }
  .cotificationLi:hover{
    background: #e6f7ff;
    cursor:pointer
  }
  .infoHeader{
    background: #e6f7ff;
    font-size:14px;
    padding:10px;
  }
  .infoDetail{
    .infoDetail_L {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
    }
    .infoDetail_R{
      margin-left:2px;
      font-size: 14px;
    }
  }
  .infodetailContext{
    font-size: 14px;
    height: 20vh;
    overflow: hidden;
    overflow-y:auto;
  }



  /* 隐藏 el-radio 的默认图标 */
  .el-radio__input {
    display: none;
  }
  /* 移除选中时的颜色改变 */
  .el-radio.is-checked .el-radio__label {
    color: inherit; /* 让文字颜色保持不变 */
  }
  /* 自定义图片的基本样式 */
  .custom-radio-image {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: cover;
    vertical-align: middle;
    margin-left: -10px;
    margin-right: 10px;
  }
</style>
<style scoped>
  /*选中时的图片样式 */
  .el-radio .custom-radio-image.active {
    background-image: url('./checked.png');
    background-color: transparent !important; /* 防止被其他.active覆盖 */
  }
</style>
